import { useState } from 'react'
import SelectCoupon from './SelectCoupon';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import ArrowLeft from '../../../../../Assets/Modals/ArrowLeft.svg';
import TickMark from '../../../../../Assets/Modals/TickMark.svg';

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers";
import { CalendarIcon } from '@mui/x-date-pickers';
import { useDispatch } from 'react-redux';
import { closeModal, setActionAlert, setActiveSection } from '../../../../../Features/dropTrackProductsSlice';
import { reactivateCoupon } from '../../../../../lib/utils/apiCalls';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDate } from '../../../../../lib/utils/utils';

import { showToast } from '../../../../../Components/Toaster/Toaster';

function ReactivateCoupon() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const defaultFormErrors = {
        couponName: '',
        discountPercent: '',
        discountPrice: '',
        date: '',
    };

    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const dates = {
        from: null,
        to: null,
    }

    const [date, setDate] = useState(dates);
    const [coupon, setCoupon] = useState({});
    const [droptrackConfirmation, setDroptrackConfirmation] = useState(false);
    const [exclusiveConfirmation, setExclusiveConfirmation] = useState(false);

    const handleCouponSelection = (coupon) => {
        setCoupon(coupon);
    }

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const handleNotifyButton = async () => {
        const validationErrors = {};

        const fromDate = new Date(date.from);
        const toDate = new Date(date.to);

        const fromTimestamp = fromDate.getTime();
        const toTimestamp = toDate.getTime();

        if(fromTimestamp || toTimestamp) {
            if(!fromTimestamp) {
                validationErrors.date = 'Select Start Date';
            }
            else if(!toTimestamp) {
                validationErrors.date = 'Select End Date';
            }
            else if(fromDate > toDate) {
                validationErrors.date = 'Start date should be earlier than End date';
            }
        }
        else {
            validationErrors.date = 'Select date range';
        }

        if(Object.keys(validationErrors).length === 0) {
            const callData = {
                startDate: fromDate.toISOString(),
                endDate: toDate.toISOString(),
                productId: coupon.id,
                isOnlyForDropTrackUsers: droptrackConfirmation,
                isOnlyForProduct: exclusiveConfirmation,
            };

            try {
                const response = await reactivateCoupon(callData);
                // eslint-disable-next-line eqeqeq
                if (response.statusCode == 10000) {
                    showToast('Existing coupon reactivated!', 'success');
                    dispatch(closeModal());
                    navigate(`${location.pathname}/${coupon.id}`);
                    dispatch(setActionAlert({
                        type: 'Existing Coupon',
                        startDate: formatDate(fromDate),
                        endDate: formatDate(toDate),
                    }));
                    dispatch(setActiveSection('insights'));
                }
            }
            catch(err) {
                showToast(`Error occurred`, 'error');
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    return (
        <div className="w-1/2 h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-5">
            {
                Object.keys(coupon).length === 0 ? 
                <SelectCoupon 
                    selectCoupon={val => handleCouponSelection(val)} 
                /> : 
                <>
                    <div className="flex items-center justify-between">
                        <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Reactivate Existing Coupons</h1>

                        <button onClick={handleButtonClick}>
                            <img src={Close} alt="Close Modal" />
                        </button>
                    </div>

                    <div className="flex gap-2 items-center mx-[-8px]">
                        <div className="p-[6px]">
                            <button onClick={() => {setCoupon({})}} className="p-1 w-6 h-6 flex items-center justify-center">
                                <img className='' src={ArrowLeft} alt="" />
                            </button>
                        </div>

                        <h2 className='font-urbanist-regular font-bold text-base text-[#121212]'>{coupon.couponName}</h2>
                    </div>

                    <div className="flex flex-col gap-10">
                        <form action="" className="flex flex-col gap-4">
                            <div className="flex flex-col gap-[14px]">
                                <div className="flex flex-col gap-2 font-urbanist-regular">
                                    <div className="flex items-center justify-between">
                                        <h1 className='font-medium text-[16px] leading-8 text-[#121212]'>
                                            Set Duration 
                                            {/* &#40;optional&#41; */}
                                        </h1>

                                        {formErrors.date && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.date}</p>}
                                    </div>
                                
                                    <p className='font-medium text-[16px] leading-[28px] text-[#666666]'>
                                        Specify your deal's duration and let the system automatically expire to bundle offer after promotional period.
                                    </p>
                                </div>

                                <div className="flex gap-8 text-black font-urbanist-regular">
                                    <div className="flex flex-col gap-1">
                                        <h1 className='font-normal text-base'>From</h1>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    label="Start Date" 
                                                    onChange={e => setDate({ ...date, from: e.$d })} 
                                                    slots={{ openPickerIcon: CalendarIcon }} 
                                                    sx={{
                                                        width: '180px'
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>

                                    <div className="flex flex-col gap-1">
                                        <h1 className='font-normal text-base'>To</h1>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    label="End Date" 
                                                    onChange={e => setDate({ ...date, to: e.$d })} 
                                                    slots={{ openPickerIcon: CalendarIcon, }} 
                                                    sx={{
                                                        width: '180px',
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-2">
                                <button 
                                    onClick={(e) => { e.preventDefault(); setDroptrackConfirmation(!droptrackConfirmation)}} 
                                    className={`flex items-center justify-center w-6 h-6 rounded-[6px] border border-[#D1D5DB] ${droptrackConfirmation && 'bg-primaryColor border-none'}`}
                                >
                                    {droptrackConfirmation && <img src={TickMark} alt="" />}
                                </button>

                                <p className='m-0 font-urbanist-regular font-normal text-[14px] leading-6'>
                                    Check this box if you want this coupon to be exclusively for Droptrack Watchers.
                                </p>
                            </div>

                            <div className="flex items-center gap-2">
                                <button 
                                    onClick={(e) => { e.preventDefault(); setExclusiveConfirmation(!exclusiveConfirmation)}} 
                                    className={`flex items-center justify-center w-6 h-6 rounded-[6px] border border-[#D1D5DB] ${exclusiveConfirmation && 'bg-primaryColor border-none'}`}
                                >
                                    {exclusiveConfirmation && <img src={TickMark} alt="" />}
                                </button>

                                <p className='m-0 font-urbanist-regular font-normal text-[14px] leading-6'>
                                    Check this box if you want this coupon to be exclusively for this product.
                                </p>
                            </div>
                        </form>

                        <button onClick={handleNotifyButton} className='bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded font-semibold text-base text-center text-buttonText' type='button'>
                            Notify DropTrack Watchers
                        </button>
                    </div>
                </>}
        </div>
    )
}

export default ReactivateCoupon;
